// extracted by mini-css-extract-plugin
export default {"LegendItem":"LegendItem--NXN7i"};